import { THEME, ThemeType } from '@/constants';
import { useTheme as useNextTheme } from 'next-themes';

const useTheme = () => {
  const { systemTheme, theme: currentTheme, setTheme } = useNextTheme();

  const theme: ThemeType = (currentTheme === THEME.SYSTEM ? systemTheme : currentTheme) as ThemeType;

  const toggleTheme = () => setTheme(theme === THEME.LIGHT ? THEME.DARK : THEME.LIGHT);

  return { theme, toggleTheme };
};

export default useTheme;
